import React, { PropsWithChildren } from 'react';

import { Box } from '@mui/material';

import { IconTooltip, IconTooltipProps } from './IconTooltip';

export const InfoTooltip: React.FC<
  PropsWithChildren<Omit<IconTooltipProps, 'color' | 'icon'>>
> = ({ children, title }) => (
  <Box display="flex">
    <Box flex="auto">{children}</Box>
    <IconTooltip title={title} placement="top-end" />
  </Box>
);
